var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 50,
    viewBox: "0 0 229 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.009 10.7043L86.5168 48.9298H75.3045L60.8127 10.7043H71.6439L80.8732 37.4624L90.1784 10.7043H101.01H101.009Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.131 10.7044V48.9298H131.291V44.4195C128.546 47.8595 124.427 50.0001 118.859 50.0001C108.714 50.0001 100.324 41.2085 100.324 29.8171C100.324 18.4257 108.714 9.63403 118.859 9.63403C124.426 9.63403 128.545 11.7747 131.291 15.2147V10.7044H141.131ZM131.291 29.8171C131.291 23.3952 126.792 19.0379 120.69 19.0379C114.588 19.0379 110.164 23.3952 110.164 29.8171C110.164 36.239 114.664 40.5963 120.69 40.5963C126.716 40.5963 131.291 36.239 131.291 29.8171Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16 10.7043V48.9298H173.32V44.6485C171.032 48.0885 167.066 50.0001 161.955 50.0001C153.871 50.0001 147.54 44.3424 147.54 34.1744V10.7043H157.379V32.951C157.379 38.1495 160.506 40.8253 164.93 40.8253C169.736 40.8253 173.32 37.9965 173.32 31.3455V10.7043H183.16Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.255 0H200.094V48.9297H190.255V0Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0632 10.7043H0V32.1827C0 42.2213 6.97479 48.9298 17.4513 48.9298C27.9279 48.9298 34.8463 42.2213 34.8463 32.1827V10.7043H28.0632ZM24.3319 26.0535C21.6028 26.0535 19.3913 23.8368 19.3913 21.1015C19.3913 18.3661 21.6038 16.1494 24.3319 16.1494C27.0599 16.1494 29.2724 18.3661 29.2724 21.1015C29.2724 23.8368 27.0599 26.0535 24.3319 26.0535Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4723 23.6467H45.0564C43.2887 23.6467 41.7422 24.8362 41.2852 26.5475L39.5266 33.1266H43.9425L45.701 26.5475C46.1581 24.8362 47.7055 23.6467 49.4723 23.6467Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5927 23.6467H52.0834C50.3167 23.6467 48.7692 24.8362 48.3121 26.5475L46.5536 33.1266H53.8194C55.5872 33.1266 57.1336 31.9371 57.5907 30.2258L59.3493 23.6467H57.5927Z",
    fill: "#0A2343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.381 36.0858V20.183H223.299C225.066 20.183 226.613 18.9936 227.07 17.2823L228.829 10.7022H220.381V0L210.545 9.29392V10.7022L210.437 10.7525C207.968 11.0483 205.887 12.8161 205.231 15.27L204.466 18.1318L203.918 20.183H210.544V36.0858C210.544 46.409 215.198 50.4571 228.999 48.9307V39.9871C223.359 40.2921 220.38 40.213 220.38 36.0858H220.381Z",
    fill: "#0A2343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUVault);
export default __webpack_public_path__ + "static/media/u-vault.743d749f9d054b20517cbef6e606b5f9.svg";
export { ForwardRef as ReactComponent };